// src/data/itemsList.js
const trays = [
  {
    name: "Dikdörtgen Mermer Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fdikd%C3%B6rtgen%20mermer%20tepsi.jpg?alt=media&token=8f281390-7ecd-4b4f-9969-6504adfe0597",
    kategori: "Tepsiler"
  },
  {
    name: "Gold Örgülü Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fgold-orgulu-tepsi.jpg?alt=media&token=3d493b91-170a-496e-af22-a1cab7d5b9aa",
    kategori: "Tepsiler"
  },
  {
    name: "Gold Kulplu Aynalı Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fgold%20kulplu%20aynal%C4%B1%20tepsi.jpg?alt=media&token=838f5c38-65d4-49d9-a0e4-fe9513824fb0",
    kategori: "Tepsiler"
  },
  {
    name: "Gold Metal Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fgold%20metal%20tepsi.jpg?alt=media&token=78f7b70e-08b1-458d-b7bf-d892d84ea2d6",
    kategori: "Tepsiler"
  },
  {
    name: "Gold Oval Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fgold%20oval%20tepsi.jpg?alt=media&token=9dda035c-a5b1-4bf8-bb10-0b8d9948c5fe",
    kategori: "Tepsiler"
  },
  {
    name: "Gümüş Aynalı Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fg%C3%BCm%C3%BC%C5%9F%20aynal%C4%B1%20tepsi.jpg?alt=media&token=7a4e7026-dbf6-475a-8ab4-93edd92b8cd8",
    kategori: "Tepsiler"
  },
  {
    name: "Gümüş Metal Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fg%C3%BCm%C3%BC%C5%9F%20metal%20tepsi.jpg?alt=media&token=79a7373e-9832-4f02-8bc9-20104b585559",
    kategori: "Tepsiler"
  },
  {
    name: "Hasır Kulplu Ahşap Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fhas%C4%B1r%20kulplu%20ah%C5%9Fap%20tepsi.jpg?alt=media&token=a610d0ae-cade-43f5-90a8-12a8f6f4edc1",
    kategori: "Tepsiler"
  },
  {
    name: "Kare Mermer Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fkare%20mermer%20tepsi.jpg?alt=media&token=668149b3-0f65-44ca-99d6-b5ae491cd838",
    kategori: "Tepsiler"
  },
  {
    name: "Okaliptus Ahşap Çerçeve Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fokaliptus%20ah%C5%9Fap%20%C3%A7er%C3%A7eve%20tepsi.jpg?alt=media&token=95acb1fc-b308-4673-be5c-b085ea628ce2",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Epoksi Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20epoksi%20tepsi.jpg?alt=media&token=eab1cc72-7279-412f-b4f8-655a79585d4d",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Kare Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20kare%20tepsi.jpg?alt=media&token=4c03f6d8-3ab1-4cfa-9c29-0556beb7a49f",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Kulplu Aynalı Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20kulplu%20aynal%C4%B1%20tepsi.jpg?alt=media&token=4c422725-8ca1-4678-9030-dd7ed2680373",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Kulplu Aynalı Tepsi2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20kulplu%20aynal%C4%B1%20tepsi2.jpg?alt=media&token=5e780622-8576-4c38-86bd-f9f457e68f66",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Prizma Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20prizma%20tepsi.jpg?alt=media&token=15cb5dd0-d374-468c-953f-9fd85dabdd65",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Sekizgen Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20sekizgen%20tepsi.jpg?alt=media&token=b704cff0-cf1b-45dc-9322-1f92cbc88a72",
    kategori: "Tepsiler"
  },
  {
    name: "Rose Yuvarlak Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Frose%20yuvarlak%20tepsi.jpg?alt=media&token=a2884e6f-b164-4800-947b-1a1d143ba28a",
    kategori: "Tepsiler"
  },
  {
    name: "Siyah Cam Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fsiyah%20cam%20tepsi.jpg?alt=media&token=dcbdc91c-e4e3-4171-b26d-1f59b942d392",
    kategori: "Tepsiler"
  },
  {
    name: "Siyah Sekizgen Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fsiyah%20sekizgen%20tepsi.jpg?alt=media&token=d2df739c-70a0-4a83-a44a-85396d52b906",
    kategori: "Tepsiler"
  },
  {
    name: "Yarı Şeffaf Epoksi Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fyar%C4%B1%20%C5%9Feffaf%20epoksi%20tepsi.jpg?alt=media&token=cc86451b-b878-4349-b867-429e62aadba1",
    kategori: "Tepsiler"
  },
  {
    name: "Yuvarlak Ahşap Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fyuvarlak%20ah%C5%9Fap%20tepsi.jpg?alt=media&token=08bdfd9e-6876-4e45-b9de-9f369e875780",
    kategori: "Tepsiler"
  },
  {
    name: "Şeffaf Cam Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2F%C5%9Feffaf%20cam%20tepsi.jpg?alt=media&token=4fbd1790-a841-472a-988c-454d8c1fab1c",
    kategori: "Tepsiler"
  },
  {
    name: "Polyester Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Ftrays%2Fpolyester%20tepsi.jpg?alt=media&token=5ffaa59c-c75c-4de4-89d7-9d7b3d3683b6",
    kategori: "Tepsiler"
  }
];
const chairs = [
  {
    name: "Ahşap Sade Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2FAh%C5%9Fap%20Sade%20Sandalye.jpg?alt=media&token=9c78c55e-45c6-4a3d-ac87-42794ce6ea44",
    kategori: "chairs"
  },
  {
    name: "Ahşap Yuvarlak Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2FAh%C5%9Fap%20Yuvarlak%20Sandalye.jpg?alt=media&token=373de158-780c-435e-993a-6dd569273d4c",
    kategori: "chairs"
  },
  {
    name: "Krem Puf Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2FKrem%20Puf%20Sandalye.jpg?alt=media&token=bc951455-6096-4858-9950-3cff51b7b49b",
    kategori: "chairs"
  },
  {
    name: "Ahşap Kare Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fah%C5%9Fap-kare-sandalye.jpg?alt=media&token=850368e2-79ac-407a-8d95-85c0acbe49a4",
    kategori: "chairs"
  },
  {
    name: "Ahşap Otantik Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fah%C5%9Fap-otantik-sandalye.jpg?alt=media&token=58c3e913-1107-4121-9299-aa845c24dc37",
    kategori: "chairs"
  },
  {
    name: "Ahşap Rattan Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fah%C5%9Fap-rattan-sandalye.jpg?alt=media&token=f26e18fa-1f5a-4ff2-86b4-ea991fbe5dad",
    kategori: "chairs"
  },
  {
    name: "Ahşap Koyu Rattan Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2FAh%C5%9Fap%20Koyu%20Rattan%20Sandalye.jpeg?alt=media&token=180ad4e9-6af6-40f2-aeda-9a6e37844dd9",
    kategori: "chairs"
  },
  {
    name: "Ahşap Siyah Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fah%C5%9Fap-siyah-sandalye.jpg?alt=media&token=464afbd4-0a06-47a4-9492-8d1285ced1d7",
    kategori: "chairs"
  },
  {
    name: "Beyaz Otantik Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fbeyaz-otantik-sandalye.jpg?alt=media&token=3c3a6275-d268-4a23-85e4-9fd0429e7f20",
    kategori: "chairs"
  },
  {
    name: "Beyaz Pleksi Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fbeyaz-pleksi-sandalye.jpg?alt=media&token=f43f6934-5b5d-4f2e-bccf-4095dd950414",
    kategori: "chairs"
  },
  {
    name: "Beyaz Rattan Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fbeyaz-rattan-sandalye.jpg?alt=media&token=ee033376-f9ac-41a8-b383-6409ac96eeb9",
    kategori: "chairs"
  },
  {
    name: "Beyaz Yuvarlak Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fbeyaz-yuvarlak-sandalye.jpg?alt=media&token=436d0cb1-94a4-45e8-ab33-e954d277af99",
    kategori: "chairs"
  },
  {
    name: "Siyah Pleksi Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2Fsiyah-pleksi-sandalye.jpg?alt=media&token=daceecd0-862c-4d83-be21-02cbf408869d",
    kategori: "chairs"
  },
  {
    name: "Şeffaf Pleksi Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2F%C5%9Eeffaf%20Pleksi%20Sandalye.jpg?alt=media&token=c38e67a5-018d-4931-85e4-6ee8a6a7f793",
    kategori: "chairs"
  },
  {
    name: "Papatya Sandalye",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fchairs%2FPapatya%20Sandalye.jpeg?alt=media&token=89f05bda-2f97-4e69-b78d-d42da5aa6123",
    kategori: "chairs"
  }
];

const neons = [
  {
    name: "Better Together",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FBetter%20Together.jpeg?alt=media&token=12341626-228c-4d8e-95f2-5e15646e786f",
    kategori: "neons"
  },
  {
    name: "Forever Together",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FForever%20Together.jpeg?alt=media&token=62a588fa-56d9-4ac7-a5ca-a33826b5b415",
    kategori: "neons"
  },
  {
    name: "Kişiye Özel",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FKi%C5%9Fiye%20%C3%96zel.jpg?alt=media&token=8dcfb77e-9afd-48e7-a462-60d82f717382",
    kategori: "neons"
  },
  {
    name: "Love Always Wins",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FLove%20Always%20Wins.jpeg?alt=media&token=e40605e5-da27-49ed-9a26-1fe722deecae",
    kategori: "neons"
  },
  {
    name: "Love You Forever",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FLove%20You%20Forever.jpeg?alt=media&token=d17d698d-860a-4f8c-b4be-72c3e3e08fc2",
    kategori: "neons"
  },
  {
    name: "Mr & Mrs",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FMr%20%26%20Mrs.jpeg?alt=media&token=31759bb4-834d-4908-80a6-f864dc1abe9b",
    kategori: "neons"
  },
  {
    name: "You & I Forever",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fneons%2FYou%20%26%20I%20Forever.jpeg?alt=media&token=9d8aaffe-1c5a-42ff-93ea-195fab0fa223",
    kategori: "neons"
  }
];
const sunumluklar = [
  {
    name: "3 Katlı Stand",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2F3%20Katl%C4%B1%20Stand.jpg?alt=media&token=3586699c-d501-4e3b-9394-1389dc745275",
    kategori: "sunumluklar"
  },
  {
    name: "Gold Kafes",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FGold%20Kafes.jpeg?alt=media&token=d82d5664-62e6-48e2-a270-20a468cb0cec",
    kategori: "sunumluklar"
  },
  {
    name: "Gold Kare Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FGold%20Kare%20Tepsi.JPEG?alt=media&token=94d2b03f-b27f-4f71-862b-dec6afa1d7ab",
    kategori: "sunumluklar"
  },
  {
    name: "Gold Prizma Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FGold%20Prizma%20Tepsi.jpg?alt=media&token=a66576c3-8b30-4e6c-91cc-46ad80bae18a",
    kategori: "sunumluklar"
  },
  {
    name: "Gold Sekizgen Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FGold%20Sekizgen%20Tepsi.JPEG?alt=media&token=2b35189f-c0fb-4ae5-a0ae-143ecce519b5",
    kategori: "sunumluklar"
  },
  {
    name: "Gümüş Dalgalı Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FG%C3%BCm%C3%BC%C5%9F%20Dalgal%C4%B1%20Tepsi..JPEG?alt=media&token=e39568bb-2084-4dd2-a178-4023dd6c4a72",
    kategori: "sunumluklar"
  },
  {
    name: "Gümüş Kafes",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FG%C3%BCm%C3%BC%C5%9F%20Kafes.jpeg?alt=media&token=073fe367-3e1d-428e-a51e-0a42685613bc",
    kategori: "sunumluklar"
  },
  {
    name: "Gümüş Prizma Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FG%C3%BCm%C3%BC%C5%9F%20Prizma%20Tepsi.jpg?alt=media&token=d1b3a576-f553-42ab-8100-28844f2bee1d",
    kategori: "sunumluklar"
  },
  {
    name: "Rose Hediyelik Kutusu",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FRose%20Hediyelik%20Kutusu.jpg?alt=media&token=13059a93-8f1e-4299-aec7-a0ba610b064a",
    kategori: "sunumluklar"
  },
  {
    name: "Rose Prizma Tepsi",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2FRose%20Prizma%20Tepsi.JPEG?alt=media&token=130f5484-7f36-4ec5-af55-4bdd07b23b7e",
    kategori: "sunumluklar"
  },
  {
    name: "Şeffaf Pleksi Stand",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsunumluklar%2F%C5%9Eeffaf%20Pleksi%20Stand.jpg?alt=media&token=7ec50ec8-022b-45fc-969f-84b063c11b63",
    kategori: "sunumluklar"
  }
];
const columns = [
  {
    name: "Kare Ahşap Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FKare%20Ah%C5%9Fap%20S%C3%BCtun.JPEG?alt=media&token=9e70f115-6c33-4e9d-80a8-65ec5ed61cf9",
    kategori: "columns"
  },
  {
    name: "Kare Beyaz Ahşap Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FKare%20Beyaz%20Ah%C5%9Fap%20S%C3%BCtun.jpg?alt=media&token=c8427341-a86d-49d7-a05f-c8e256cbc87b",
    kategori: "columns"
  },
  {
    name: "Kare Siyah Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FKare%20Siyah%20S%C3%BCtun.jpeg?alt=media&token=2d6a837b-e119-4084-9618-a4e7196bda50",
    kategori: "columns"
  },
  {
    name: "Pleksi Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FPleksi%20S%C3%BCtun.jpg?alt=media&token=b34a7ded-ddfc-4180-b6ca-83d4877bd74f",
    kategori: "columns"
  },
  {
    name: "Rose Oval Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FRose%20Oval%20S%C3%BCtun.jpg?alt=media&token=c78a6414-699a-418d-b85b-844263ff80ec",
    kategori: "columns"
  },
  {
    name: "Yuvarlak Ahşap Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FYuvarlak%20Ah%C5%9Fap%20S%C3%BCtun.jpg?alt=media&token=4900087f-26bf-4c98-94c7-6786057031d5",
    kategori: "columns"
  },
  {
    name: "Yuvarlak Beyaz Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FYuvarlak%20Beyaz%20S%C3%BCtun.JPEG?alt=media&token=2481b8c6-5c2b-494a-bd57-3284850184c0",
    kategori: "columns"
  },
  {
    name: "Yuvarlak Metal Eskitme Sütun",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fcolumns%2FYuvarlak%20Metal%20Eskitme%20S%C3%BCtun.jpeg?alt=media&token=c47ec3b5-0dc4-49e6-a936-2796be57ac32",
    kategori: "columns"
  }
];
const sehpalar = [
  {
    name: "Ahşap Beyaz Yuvarlak Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Beyaz%20Yuvarlak%20Orta%20Sehpa.jpg?alt=media&token=b531fc0b-eff3-4b1f-b712-e323ad8b9ce9",
  },
  {
    name: "Ahşap Beyaz Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Beyaz%20Orta%20Sehpa.jpeg?alt=media&token=1170868c-3fec-45e2-b975-00737c0df182",
  },
  {
    name: "Ahşap Beyaz Çiçekli Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Beyaz%20%C3%87i%C3%A7ekli%20Orta%20Sehpa.jpg?alt=media&token=27a58bcc-8b7c-4ce7-a4aa-37e2141704e8",
  },
  {
    name: "Ahşap Kare Çiçekli Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Kare%20%C3%87i%C3%A7ekli%20Orta%20Sehpa.jpeg?alt=media&token=7f77859e-4711-4e8d-97d4-431f5595cace",
  },
  {
    name: "Ahşap Mermer Desenli Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Mermer%20Desenli%20Orta%20Sehpa.jpg?alt=media&token=7be75757-4952-4eb4-93dd-244db8b647f5",
  },
  {
    name: "Ahşap Yuvarlak Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Yuvarlak%20Orta%20Sehpa.jpg?alt=media&token=92c3bd01-69ab-4261-9366-042bd6651114",
  },
  {
    name: "Ahşap Yuvarlak Dikey Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Yuvarlak%20Dikey%20Sehpa.jpeg?alt=media&token=4ce5f7fc-8156-4615-b99e-c46349ddfc5b",
  },
  {
    name: "Ahşap Yuvarlak Çiçekli Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FAh%C5%9Fap%20Yuvarlak%20%C3%87i%C3%A7ekli%20Orta%20Sehpa.jpeg?alt=media&token=4e60a819-391c-4ac7-a928-021f0121f490",
  },
  {
    name: "Hasır Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2FHas%C4%B1r%20Orta%20Sehpa.jpeg?alt=media&token=efa3bea7-3050-4780-9794-b3b6f4cbff94",
  },
  {
    name: "Şeffaf Pleksi Orta Sehpa",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsehpalar%2F%C5%9Eeffaf%20Pleksi%20Orta%20Sehpa.jpg?alt=media&token=11eb6fa8-a704-434b-a13f-48a7bfb61191",
  },
];
const mumluklar = [
  {
    name: "Ahşap Kafes Mumluk",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2FAh%C5%9Fap%20Kafes%20Mumluk.jpg?alt=media&token=def8c495-2712-4177-9904-5766fceb6599",
  },
  {
    name: "Ahşap Ağır Kafes Mumluk",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2FAh%C5%9Fap%20A%C4%9F%C4%B1r%20Kafes%20Mumluk.jpeg?alt=media&token=2122aa5b-7740-46bd-8c10-d1d6ba80a354",
  },
  {
    name: "Beyaz Silindir Mum",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2FBeyaz%20Silindir%20Mum.jpg?alt=media&token=1c465d61-a967-4a1b-9240-7e84ca7c4907",
  },
  {
    name: "Metal Kahverengi Kafes Mumluk",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2FMetal%20Kahverengi%20Kafes%20Mumluk.JPEG?alt=media&token=e25a13f2-d16b-4697-901b-760bdd03a3b7",
  },
  {
    name: "Siyah Metal Kafes",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2FSiyah%20Metal%20Kafes.JPEG?alt=media&token=26170d0c-c428-4ce4-b270-c33972b9b036",
  },
  {
    name: "Üçlü Dikey Ahşap Mumluk",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2F%C3%9C%C3%A7l%C3%BC%20Dikey%20Ah%C5%9Fap%20Mumluk.JPEG?alt=media&token=66c31920-cb5f-400c-9936-731d0374d3a2",
  },
  {
    name: "İkili Hasır Mumluk",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fmumluklar%2F%C4%B0kili%20Has%C4%B1r%20Mumluk.JPEG?alt=media&token=9b1f0940-10d1-410a-ac51-6e7190af289b",
  },
];
const shamdanlar = [
  {
    name: "Beyaz Şamdan",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FBeyaz%20%C5%9Eamdan.jpg?alt=media&token=bc393eba-06f7-4069-bd13-7fc4819d26a2"
  },
  {
    name: "Beyaz Şamdan2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FBeyaz%20%C5%9Eamdan2.JPEG?alt=media&token=24cf813a-3473-480a-b706-3ec45a2fa26f"
  },
  {
    name: "Rose Şamdan",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FRose%20%C5%9Eamdan.JPEG?alt=media&token=930decf3-8c37-4002-9b94-30cef95f79ad"
  },
  {
    name: "Rose Şamdan2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FRose%20%C5%9Eamdan2.JPEG?alt=media&token=0bb0d306-bd5a-4b17-a85e-7ffcd53711e6"
  },
  {
    name: "Siyah Mızrak Şamdan",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FSiyah%20M%C4%B1zrak%20%C5%9Eamdan.jpeg?alt=media&token=1b0e4e52-14e3-43e7-af40-dffeaeb1d4ee"
  },
  {
    name: "Siyah Mızrak Şamdan2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FSiyah%20M%C4%B1zrak%20%C5%9Eamdan2.jpeg?alt=media&token=29885b58-42a9-4a34-9828-681b16c29f14"
  },
  {
    name: "Siyah Şamdan",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FSiyah%20%C5%9Eamdan.jpeg?alt=media&token=a5c84aca-48fb-4e34-b6d6-984f95e8b875"
  },
  {
    name: "Siyah Şamdan2",
    image: "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fshamdanlar%2FSiyah%20%C5%9Eamdan2.jpeg?alt=media&token=8547d427-1833-473a-9a8a-d8a0c5256f24"
  }
];

const benchler = [
  {
    name: "Beyaz Bench",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fbenchler%2FBeyaz%20Bench.jpg?alt=media&token=96490ab0-47c4-440c-ae8b-3cdb0ddcec9e",
    kategori: "benchler",
  },
  {
    name: "Rose Bench",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fbenchler%2FRose%20Bench.webp?alt=media&token=def10d35-b6de-4f0e-8cd8-d3d38a60d5e3",
    kategori: "benchler",
  },
  {
    name: "Siyah Bench",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fbenchler%2Fsiyah-bench.jpg?alt=media&token=903a9402-80b2-4adb-a0e6-04988870197a",
    kategori: "benchler",
  },
];

const vazolar = [
  {
    name: "Hasır Küp Vazo",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fvazolar%2FHas%C4%B1r%20K%C3%BCp%20Vazo.jpg?alt=media&token=0aedb443-ec73-4a9f-a8e6-c17c64e40c58",
    kategori: "vazolar",
  },
  {
    name: "Hasır Oval Vazo",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fvazolar%2FHas%C4%B1r%20Oval%20Vazo.JPEG?alt=media&token=68855b73-0654-41be-8fa9-96a06bcb55e9",
    kategori: "vazolar",
  },
  {
    name: "Okaliptus Vazo",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fvazolar%2FOkaliptus%20Vazo.JPEG?alt=media&token=71c825cc-7719-4b3d-8088-eb8a90248f92",
    kategori: "vazolar",
  },
  {
    name: "Ahşap Ağır Vazo",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fvazolar%2FAh%C5%9Fap%20A%C4%9F%C4%B1r%20Vazo.jpeg?alt=media&token=d111ad7f-94ef-4e9b-bce1-fd6e85981179",
    kategori: "vazolar",
  },
];

const pastastandlari = [
  {
    name: "Gümüş Yuvarlak Stand",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fpastastandlari%2FGumus_Yuvarlak_Stand.jpeg?alt=media&token=f23b4a13-a816-4f55-a1d9-d8e813a1d9a2",
    kategori: "pastastandlari",
  },
  {
    name: "Rose Kare Stand",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fpastastandlari%2FRose%20Kare%20Stand.jpg?alt=media&token=a05f0a92-e05a-4cd1-b973-0a0b203b6056",
    kategori: "pastastandlari",
  },
  {
    name: "Rose Yuvarlak Stand",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fpastastandlari%2FRose_Yuvarlak_Stand.jpeg?alt=media&token=d8094a96-f304-4acb-8a56-47baeef28202",
    kategori: "pastastandlari",
  },
];

const suplalar = [
  {
    name: "Hasır Supla",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsuplalar%2FHas%C4%B1r%20Supla.jpeg?alt=media&token=4238a9d4-9761-46b4-a744-36434dda9509",
    kategori: "suplalar",
  },
  {
    name: "İnci Supla",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2Fsuplalar%2F%C4%B0nci%20Supla.jpeg?alt=media&token=37c79750-15d7-4c77-8e29-d22eed455965",
    kategori: "suplalar",
  },
];
const Halılar = [
  {
    name: "Hasır Halı",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2FHal%C4%B1lar%2FHas%C4%B1r%20Hal%C4%B1.jpeg?alt=media&token=4998a916-9c20-43f3-a3f8-8621926d2e1b",
    kategori: "Halılar",
  },
  ];
  const Işıklar = [
  {
    name: "Ray Spot",
    image:
      "https://firebasestorage.googleapis.com/v0/b/organizasyon-panel.firebasestorage.app/o/materials%2FI%C5%9F%C4%B1klar%2FRay%20Spot.jpeg?alt=media&token=95fa8623-c5f9-4595-a268-2dc51654ba22",
    kategori: "Işıklar",
  },
  ];

export { trays, chairs, neons, sunumluklar, columns, sehpalar, mumluklar, shamdanlar, benchler, vazolar, pastastandlari, suplalar, Halılar, Işıklar };